import { render, staticRenderFns } from "./no_availability_banner.vue?vue&type=template&id=3445dd1c&scoped=true&"
import script from "./no_availability_banner.vue?vue&type=script&lang=js&"
export * from "./no_availability_banner.vue?vue&type=script&lang=js&"
import style0 from "./no_availability_banner.vue?vue&type=style&index=0&id=3445dd1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445dd1c",
  null
  
)

export default component.exports